<template>
  <b-modal :title="modalTitle" v-model="deleteModalOpen" @ok="deleteRecord()" ok-variant="info">
      {{modalMsg}}
      <div class="delete-buttons" v-if="loginUserRoleName=='Admin'">
        <b-button 
          variant="outline-primary" 
          :pressed.sync="markAsDeleted">{{markAsDeletedLabel}} 
            <i v-if="markAsDeleted" class="cui-check"></i>
        </b-button>
        <b-button 
          variant="outline-success" 
          :pressed.sync="permenentDelete">{{permenentDeleteLabel}} 
          <i v-if="permenentDelete" class="cui-check"></i>
        </b-button>
      </div>
    </b-modal>
</template>
<script>
export default {
  name: "DeleteConfirmationModal",
  props: {
    modalTitle: {
      type: String,
      default:function(){
        return 'Delete';
      }
    },
    modalMsg:{
      type: String,
      default:function(){
        return 'Delete Record';
      }
    },
    loginUserRoleName:{
      type: String,
      default:function(){
        return 'NotAdmin';
      }
    },
    markAsDeletedLabel:{
      type: String,
      default:function(){
        return 'Tick As Deleted';
      }
    },
    permenentDeleteLabel:{
      type: String,
      default:function(){
        return 'Permenently Delete';
      }
    },
  },
  data() {
    return {
      deleteModalOpen:false,
      markAsDeleted: true,
      permenentDelete: false,
    }
  },
  mounted() {
  },
  watch: {
    markAsDeleted: function (val) {
      this.permenentDelete = !val;
    },
    permenentDelete: function (val) {
      this.markAsDeleted = !val;
    }
  },
  methods:{
    openModal(){
      let that = this;
      that.deleteModalOpen=true;
      that.markAsDeleted=true;
      that.permenentDelete=false;
    },
    deleteRecord() {
      let that = this;
      that.deleteModalOpen = false;
      if(that.loginUserRoleName!='Admin'){
        that.$emit('toggle', {deleteAction: 'MARK-AS-DELETED'});
      }else{
        if(that.markAsDeleted){
          that.$emit('toggle', {deleteAction: 'MARK-AS-DELETED'});
        }else if(that.permenentDelete){
          that.$emit('toggle', {deleteAction: 'PERMENENT-DELETE'});
        }
      }
    },
  }
}
</script>
<style scoped lang="less">
.delete-buttons{
  display: block;
  margin-top:10px;
  .btn{
    margin-right:10px;
  }
}
</style>